import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ConsumptionValuesVM } from '@innogy/become-a-customer/shared/interfaces';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { TranslatePipe } from '@ngx-translate/core';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { CrntIcon } from '@essent/current-web-angular';

@Component({
  selector: 'wl-order-overview-consumption[consumptionValues]',
  templateUrl: './order-overview-consumption.component.html',
  styleUrls: [
    './order-overview-consumption.component.ed.scss',
    './order-overview-consumption.component.essent.scss',
  ],
  standalone: true,
  imports: [
    CommonModule,
    FontAwesomeModule,
    AutomationIdDirective,
    AutomationIdDirective,
    TranslatePipe,
    CSCaptureDirective,
    CrntIcon,
  ],
})
export class OrderOverviewConsumptionComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() consumptionValues!: ConsumptionValuesVM;
}
